export default __webpack_public_path__ + "static/media/social-02@2x.7f6ace5d.jpg";